import Service from './abstract';
import usersService from './users';
const defaultPlatform = 5;
const sellerPlatform = 8;

class Login extends Service {
    constructor () {
        super('auth');
    }

    login (email, password) {
        return this.post({
            url: `${this.baseUrlLogin}/login?with=${usersService.fullWith}`,
            data: {
                idPlatform: defaultPlatform,
                payload: { email, password }
            }
        })
            .then(res => usersService.normalize(res));
    }

    recover (id) {
        return this.post({
            url: `${this.baseUrlLogin}/recover`,
            data: {
                idUser: id
            }
        });
    }

    registerSellerAccount (data) {
        return this.post({
            url: `${this.basePath}/register/username`,
            data: {
                idPlatform: sellerPlatform,
                idUser: data.id,
                username: data.username,
                password: data.password
            }
        });
    }

    register (data) {
        const options = {
            url: `${this.baseUrlLogin}/register`,
            data
        };

        return this.post(options)
            .then(res => {
                return this.post({
                    url: `${this.baseUrlLogin}/verify`,
                    data: {
                        idPlatform: defaultPlatform,
                        email: data.person.emails[0].email,
                        metadata: {
                            user: {
                                id: res.id,
                                fullname: data.fullname
                            },
                            subject: 'Finket | Verificación de cuenta',
                            url: `https://${window.location.host}/auth/verify`
                        }
                    }
                });
            });
    }

    verifyCommerce (data) {
        return this.post({
            url: `${this.baseUrlLogin}/verify`,
            data
        });
    }

    validateForgot (data) {
        return this.post({
            url: `${this.baseUrlLogin}/password/forgot/validate`,
            data
        });
    }

    validateEmail (body) {
        return this.post({
            url: `${this.baseUrlLogin}/validate`,
            body
        });
    }

    validate (body) {
        return this.post({
            url: `${this.baseUrlLogin}/validate`,
            body
        });
    }

    change (data) {
        return this.post({
            url: `${this.baseUrlLogin}/password/recover`,
            data
        });
    }

    changeEmail (body) {
        return this.post({
            url: `${this.baseUrlLogin}/verify`,
            body
        });
    }

    forgot (body) {
        return this.post({
            url: `${this.baseUrlLogin}/password/forgot`,
            body
        });
    }

    resetPasswordSeller (data) {
        return this.post({
            url: `${this.baseUrlLogin}/password/recover`,
            data
        });
    }
}

export default new Login();
